import { render } from "./aViewMore.vue?vue&type=template&id=e17ede0e&ts=true"
import script from "./aViewMore.vue?vue&type=script&lang=ts"
export * from "./aViewMore.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__